import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import accessRequests from './modules/access-requests'
import client from './modules/client'
import components from './modules/components'
import config from './modules/config'
import groups from './modules/groups'
import items from './modules/items'
import media from './modules/media'
import members from './modules/members'
import modules from './modules/modules'
import register from './modules/register'
import reports from './modules/reports'
import sidebar from './modules/sidebar'
import suggestions from './modules/suggestions'
import tenants from './modules/tenants'
import topics from './modules/topics'
import token from './modules/token'
import users from './modules/users'
import bioreq from './modules/bioreq'
import knowledgechecks from './modules/knowledgechecks'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    accessRequests,
    client,
    components,
    config,
    groups,
    items,
    media,
    members,
    modules,
    register,
    reports,
    sidebar,
    suggestions,
    tenants,
    topics,
    token,
    users,
    bioreq,
    knowledgechecks
  },
  plugins: [
    createPersistedState({
      // persist all but register
      paths: [
        'accessRequests',
        'client',
        'components',
        'config',
        'groups',
        'items',
        'media',
        'members',
        'modules',
        'reports',
        'suggestions',
        'tenants',
        'token',
        'topics',
        'users',
        'bioreq'
      ]
    })
  ]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js